export default __webpack_public_path__ + "static/media/jack_of_diamonds2.afe516e9.png";